export default __webpack_public_path__ + "static/media/map.c1b3f1e6.jpg";